import MaintenanceMode from "components/MaintenanceMode";
import NotAllowedTime from "components/NotAllowedTime"; 
import useAuth from "hooks/useAuth";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSystemInfo } from "redux/slices/systemInfo.slice";

export default function SystemGuard({ children }) {
  const dispatch = useDispatch();
  const { systemInfo } = useSelector((state) => state.systemInfo);
  const info = systemInfo?.data?.[0];
  const systemStatus = info?.systemStatus;
  const maintenanceTime = info?.maintenanceTime;
  const allowedStartTime = info?.allowedStartTime; 
  const allowedEndTime = info?.allowedEndTime;     
  const { user, accessToken } = useAuth();

  useEffect(() => {
    dispatch(getSystemInfo({}));
  }, [dispatch, accessToken]);

  if (!systemInfo) return null;

  // 1. Maintenance check
  if (
    systemStatus &&
    systemStatus !== "active" &&
    process.env.NODE_ENV !== "development"
  ) {
    return <MaintenanceMode maintenanceTime={maintenanceTime} />;
  }

  // 2. Allowed time check in Mogadishu timezone
  if (info?.checkAllowedTime && allowedStartTime && allowedEndTime) {
    const mogadishuTime = new Date(
      new Date().toLocaleString("en-US", { timeZone: "Africa/Mogadishu" })
    );

    const mogadishuHour = mogadishuTime.getHours();
    const mogadishuMinute = mogadishuTime.getMinutes();
    const currentMinutes = mogadishuHour * 60 + mogadishuMinute;

    const [startHour, startMin] = allowedStartTime.split(":").map(Number);
    const [endHour, endMin] = allowedEndTime.split(":").map(Number);
    const startMinutes = startHour * 60 + startMin;
    const endMinutes = endHour * 60 + endMin;

    let isAllowed = false;
    if (startMinutes <= endMinutes) {
      isAllowed = currentMinutes >= startMinutes && currentMinutes <= endMinutes;
    } else {
      isAllowed = currentMinutes >= startMinutes || currentMinutes <= endMinutes;
    }

    if (!isAllowed && process.env.NODE_ENV !== "development") {
      return <NotAllowedTime allowedStart={allowedStartTime} allowedEnd={allowedEndTime} />;
    }
  }

  return children;
}
